import { render, staticRenderFns } from "./Platform.vue?vue&type=template&id=bd8a49cc&scoped=true&"
import script from "./Platform.vue?vue&type=script&lang=js&"
export * from "./Platform.vue?vue&type=script&lang=js&"
import style0 from "./Platform.vue?vue&type=style&index=0&id=bd8a49cc&lang=scss&scoped=true&"
import style1 from "./Platform.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8a49cc",
  null
  
)

export default component.exports